import apiService from './api';

/** Paramètres query pour GET /api/members (liste paginée / filtres). */
function memberListParams(filters = {}) {
  const params = {};
  if (filters.limit != null) params.limit = filters.limit;
  if (filters.offset != null) params.offset = filters.offset;
  if (filters.company_id != null && filters.company_id !== '') {
    params.company_id = filters.company_id;
  }
  if (filters.type) params.type = filters.type;
  if (filters.search_term) params.search_term = filters.search_term;
  if (filters.active_only === true) params.active_only = 'true';
  if (filters.agent_id != null && filters.agent_id !== '') params.agent_id = filters.agent_id;
  if (filters.archived) params.archived = filters.archived === true ? 'true' : filters.archived;
  return params;
}

export async function lookupMembersByMatricule(matricule) {
  return apiService.get('/members/lookup', {
    params: { matricule: String(matricule).trim() }
  });
}

async function getAllMembers(filters = {}, fetchOptions = {}) {
  return apiService.get('/members', {
    params: memberListParams(filters),
    ...fetchOptions
  });
}

async function createMember(payload) {
  return apiService.post('/members', payload);
}

async function updateMember(id, payload) {
  return apiService.put(`/members/${id}`, payload);
}

async function deleteMember(id) {
  return apiService.delete(`/members/${id}`);
}

/** Archive (débauche) un adhérent sans le supprimer. Pour un agent, son foyer suit. */
async function archiveMember(id, reason) {
  return apiService.patch(`/members/${id}/archive`, reason ? { reason } : {});
}

/** Réintègre (réembauche) un adhérent archivé. Pour un agent, son foyer suit. */
async function restoreMember(id) {
  return apiService.patch(`/members/${id}/restore`, {});
}

/** Archive (débauche) plusieurs adhérents en lot. */
async function archiveMembers(ids, reason) {
  return apiService.patch('/members/bulk/archive', {
    ids,
    ...(reason ? { reason } : {})
  });
}

/** Réintègre (réembauche) plusieurs adhérents archivés en lot. */
async function restoreMembers(ids) {
  return apiService.patch('/members/bulk/restore', { ids });
}

/** Supprime définitivement plusieurs adhérents archivés (irréversible). */
async function deleteMembers(ids) {
  return apiService.post('/members/bulk/delete', { ids });
}

async function getDependentsByAgent(agentId, { archived = false } = {}) {
  return apiService.get(`/members/${agentId}/dependents`, {
    params: archived ? { archived: archived === true ? 'true' : archived } : undefined
  });
}

async function importDNS(payload) {
  return apiService.post('/members/import-dns', payload);
}

/** Prévisualise une débauche en masse : résout les matricules d'une société. */
async function previewArchiveImport({ company_id, matricules, entries }) {
  return apiService.post('/members/archive-preview', {
    company_id,
    ...(entries ? { entries } : { matricules })
  });
}

/** Exécute la débauche en masse (archivage) à partir d'une liste de matricules. */
async function runArchiveImport({ company_id, matricules, member_ids, reason }) {
  return apiService.post('/members/archive-import', {
    company_id,
    ...(member_ids ? { member_ids } : { matricules }),
    ...(reason ? { reason } : {})
  });
}

const MemberService = {
  getAllMembers,
  createMember,
  updateMember,
  deleteMember,
  archiveMember,
  restoreMember,
  archiveMembers,
  restoreMembers,
  deleteMembers,
  getDependentsByAgent,
  importDNS,
  previewArchiveImport,
  runArchiveImport
};

export default MemberService;
